/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { ROUTER_TECHNICAL_DATA } from 'app/AppRouter';
import { TECHNICAL_DATA_TAB } from 'domains/catalog/Catalog.types';
import { getCatalogSourceUrl } from 'domains/catalog/Catalog.utils';
import { fetchIAMAvailableModulesRequestSaga, getIAMAvailableModules } from 'domains/catalog/CatalogIam.store';
import { UserRole } from 'domains/user';
import {
  getHasAccessToTechnicalLinks,
  notAuthorizedTab,
  notAvailableTab,
  notLoadedTab,
} from 'pages/CatalogPage/common/CatalogBanner/TabCommon';
import { VehicleTechnicalData } from 'pages/CatalogPage/IAM/VehicleTechnicalData/VehicleTechnicalData';
import { Text } from 'UI';
import { getCondArrayItem, getData, hasUserR3WithSubscriptionL234 } from 'utils';

export const TabTechnicalData = ({
  isIam,
  versionCode,
  userRights,
  renderVehicleTabContent,
  vehicleDetail,
  includeVehicleTabContent = true,
}: {
  isIam: boolean;
  versionCode: string | undefined;
  userRights: UserRole[] | undefined;
  renderVehicleTabContent: JSX.Element;
  vehicleDetail: VehicleDetail;
  includeVehicleTabContent?: boolean;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const availableDataModule = useSelector(getIAMAvailableModules);
  const availableDataModuleData = getData(availableDataModule);
  const availableTechnicalDataModule = availableDataModuleData?.availableData.find((d) => d.name === 'adjustments')
    ?.dataAvailable;
  const label = t('catalog.parts.category.technical_data', 'Technical data');
  const key = 9;
  const link = `${getCatalogSourceUrl(vehicleDetail.catalogSource)}/${
    vehicleDetail.vehicleKey
  }${ROUTER_TECHNICAL_DATA}`;
  const handleTab = () => {
    if (!availableDataModule && hasUserR3WithSubscriptionL234(userRights)) {
      //R3 or R3_MOTRIO with enough rights must trigger loading by clicking on tab
      dispatch(fetchIAMAvailableModulesRequestSaga());
      return notLoadedTab({ key, label, link, dataCy: 'tab-technical-data-not-loaded' });
    }
    if (!availableTechnicalDataModule) {
      return notAvailableTab({ key, label, dataCy: 'tab-technical-data-not-available', link });
    }
    return getHasAccessToTechnicalLinks({ isIam, userRights, versionCode })
      ? {
          key,
          label: (
            <Text type={'lead_text_white'} noWrap>
              {label}
            </Text>
          ),
          component: (
            <>
              {includeVehicleTabContent && renderVehicleTabContent}
              <VehicleTechnicalData tabKey={TECHNICAL_DATA_TAB} />
            </>
          ),
          link,
          dataCy: 'tab-technical-data',
        }
      : notAuthorizedTab({ key, label, dataCy: 'tab-technical-data-no-access' });
  };

  return getCondArrayItem((isIam || Boolean(versionCode)) && handleTab());
};
